import {
  GET_UNITMEASURE_FAIL,
  GET_UNITMEASURE_SUCCESS,
  GET_UNITMEASURES_FAIL,
  GET_UNITMEASURES_SUCCESS,
  ADD_UNITMEASURE_SUCCESS,
  ADD_UNITMEASURE_FAIL,
  UPDATE_UNITMEASURE_SUCCESS,
  UPDATE_UNITMEASURE_FAIL,
  DELETE_UNITMEASURE_SUCCESS,
  DELETE_UNITMEASURE_FAIL,  
  SET_STATE_UNITMEASURE
} from "./actionTypes";

const INIT_STATE = {
  unitmeasures: [],
  unitmeasure: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const unitMeasures = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_UNITMEASURES_SUCCESS:
      return {
        ...state,
        unitmeasures: action.payload.unitmeasures,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_UNITMEASURE:
      return { ...state, loading: action.payload }

    case GET_UNITMEASURES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_UNITMEASURE_SUCCESS:
      return {
        ...state,
        unitmeasures: [...state.unitmeasures, action.payload],
      };

    case ADD_UNITMEASURE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_UNITMEASURE_SUCCESS:
      return {
        ...state,
        unitmeasures: state.unitmeasures.map(unitmeasure =>
          unitmeasure.id.toString() === action.payload.id.toString()
            ? { ...action.payload, unitmeasure }
            : unitmeasure
        ),
      };

    case UPDATE_UNITMEASURE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_UNITMEASURE_SUCCESS:
      return {
        ...state,
        unitmeasures: state.unitmeasures.filter(
          unitmeasure => unitmeasure.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_UNITMEASURE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_UNITMEASURE_SUCCESS:
      return {
        ...state,
        unitmeasure: action.payload,
      };

    case GET_UNITMEASURE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default unitMeasures;
